import { Component, Inject } from '@angular/core';

import get from 'lodash/get';

import { ISitemap, SITEMAP } from 'pbc.angular';
import { ISorterConfig } from 'pbc.types';

import { ReisekostenabrechnungStatiQuerySorterConfig } from 'fa-kt.types';
import { ReisekostenabrechnungStatiService } from '../service';

@Component({
  selector: 'fa-kt-reisekostenabrechnung-stati-sorter',
  templateUrl: './reisekostenabrechnung-stati-sorter.component.html',
  styleUrls: ['./reisekostenabrechnung-stati-sorter.component.css'],
})
export class ReisekostenabrechnungStatiSorterComponent {
  ReisekostenabrechnungStatiSorterConfig: ISorterConfig;

  constructor(
    @Inject(SITEMAP) private sitemap: ISitemap,
    public reisekostenabrechnungStati: ReisekostenabrechnungStatiService,
  ) {
    this.ReisekostenabrechnungStatiSorterConfig = ReisekostenabrechnungStatiQuerySorterConfig.map((filter) => ({ ...filter, title: get(sitemap, filter.title, filter.title) as string }));
    /* << update    */
    /*    update >> */
  }
}
